import styled, { css } from 'styled-components';

import mixin from '../../../_foundations/Mixin';

export const ListItem = styled.div`
  ${(props) => {
    const padding = props.padding || '1rem 1rem 1rem 1.25rem';
    const backgroundColor = props.backgroundColor || 'neutral-10';
    return css`
      background-color: var(--${backgroundColor});
      padding: ${padding};
      ${mixin.border()}
      ${mixin.horizontalFlow()}
      justify-content: space-between;
      cursor: 'auto';
      ${props.onClick &&
      css`
        &:hover {
          cursor: pointer;
          background: var(--neutral-100);
        }
      `}
    `;
  }}
  ${(props) =>
    props.indicator &&
    css`
      & {
        position: relative;
      }
      &:after {
        position: absolute;
        top: 4px;
        bottom: 4px;
        left: 4px;
        background: var(--${props.indicator});
        width: 2px;
        content: '';
      }
    `}
  ${(props) =>
    props.selected &&
    css`
      &,
      &:hover {
        background: var(--blue-100);
      }
    `}
  justify-content: space-between;
`;

export default ListItem;
